import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "date-inputs-container flex-center w-100"
}
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = { class: "d-flex align-center mb-2" }
const _hoisted_4 = { class: "text-body-2 mr-2" }
const _hoisted_5 = { class: "text-body-2" }

import { ref, computed } from 'vue'
import store from '@/app/store'


export default {
  __name: 'HotelChainSelector',
  setup(__props) {

const selectedHotel = ref(store.getters.hotelId || '')

const hotelChainId = computed(() => store.getters.hotelChainId)
const hotelChainHotels = computed(
  () =>
    store.state.hotelChain?.hotelChainHotels?.map((hotel) => ({
      id: hotel.hotelId,
      name: `${hotel.hotelName} (${hotel.cityName}, ${hotel.countryName})`
    })) || []
)

const handleHotelChange = async (hotelId) => {
  if (hotelId) {
    selectedHotel.value = store.getters.hotelId
    window.location.href = `${document.location.origin}/${hotelId}`
  }
}

return (_ctx, _cache) => {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_v_select = _resolveComponent("v-select")

  return (hotelChainId.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_fa_icon, { icon: ['far', 'hotel'] })
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('App#Search#HotelChain Select hotel')), 1)
          ]),
          _createVNode(_component_v_select, {
            modelValue: selectedHotel.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => ((selectedHotel).value = $event)),
              handleHotelChange
            ],
            items: hotelChainHotels.value,
            "item-title": "name",
            "item-value": "id",
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "items"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}